export const recordError = (errorMsg: any, logToConsole?: boolean) => {
  if (logToConsole) console.error(errorMsg);
  else {
    (window.Rollbar ?? console).error(errorMsg);
    if (window.cwr) window.cwr('recordError', errorMsg);
  }
};
